// error constants
export const NO_ERROR = 0;
export const NO_ERROR_2 = 2;
export const UNAUTHORIZED = 997;
export const MULTIPLE_ERRORS = 999;
export const LOW_WALLET_BALANCE = 12;
